import React from 'react'

import { useCurrentModal } from '../../../components/modals/ModalsContext'
import Form from '../../../packages/kiti/components/form/form/Form'
import GeneralSection from './sections/GeneralSection'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'
import useHandleSubmit from './_helpers/handleSubmit'

const EditActionPlanForm = () => {
  const {
    data: { onSubmit, ...actionPlan }
  } = useCurrentModal()

  const [request, loading] = useHandleSubmit()

  return (
    <Form loading={loading} onSubmit={request} initialState={actionPlan || {}}>
      <GeneralSection />
      <SubmitBar loading={loading} />
    </Form>
  )
}

export default EditActionPlanForm
